import MLayout from "../views/mobile/layout/";

const routes = [
  {
    path: '/',
    component: MLayout,
    redirect: "/m",
    children: [
      {
        path: "/m",
        redirect: "/index", // 页面重定向
      },
      // {
      //   // 主页 审核专用页面
      //   path: "/m/index",
      //   name: "Index",
      //   component: () =>
      //     import(/* webpackChunkName: "Medilink" */ "../views/home/index"),
      // },
      {
        // 主页
        path: "/m/index",
        name: "Index",
        component: () =>
          import(/* webpackChunkName: "homeMobile" */ "../views/mobile/index"),
      },
      {
        // 关于我们
        path: "/m/about",
        name: "About",
        component: () =>
          import(/* webpackChunkName: "aboutMobile" */ "../views/mobile/about"),
      },
      {
        // 第三方服务
        path: "/m/thirdService",
        name: "ThirdService",
        component: () =>
          import(/* webpackChunkName: "thirdServiceMobile" */ "../views/mobile/thirdService"),
      },
      {
        // 企业健康管理方案
        path: "/m/thirdService/healthPlan",
        name: "ThirdServiceHealthPlan",
        component: () =>
          import(/* webpackChunkName: "thirdServiceMobile" */ "../views/mobile/thirdService/company"),
      },
      {
        // 产品详情 --新燕宝2022
        path: "/m/productDetails/:productCode",
        name: "productDetails",
        component: () =>
          import(/* webpackChunkName: "ProductMobile" */ "../views/mobile/productDetails/index"),
      },
      {
        // 企业保健服务
        path: "/m/medicalService/company",
        name: "MedicalCompany",
        component: () =>
          import(/* webpackChunkName: "MedicalCompanyMobile" */ "../views/mobile/medicalService/company"),
      },
      {
        // 企业保健服务 诊所
        path: "/m/medicalService/clinic/:clinic",
        name: "MedicalClinic",
        component: () =>
          import(/* webpackChunkName: "MedicalYxMobile" */ "../views/mobile/medicalService/clinic"),
      },
      {
        // 特色服务
        path: "/m/featureSevice",
        name: "featureSevice",
        component: () =>
          import(/* webpackChunkName: "featureSeviceMobile" */ "../views/mobile/featureSevice"),
      },
      {
        // 个人健康管理方案
        path: "/m/products",
        name: "products",
        component: () =>
          import(/* webpackChunkName: "ProductMobile" */ "../views/mobile/products"),
      },
      {
        // 加入我们的网络
        path: "/m/joinus",
        name: "joinus",
        component: () =>
          import(/* webpackChunkName: "joinusMobile" */ "../views/mobile/joinus"),
      }
    ]
  }
]
export default routes